exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___17K-g{background-color:#f8f8f8;display:block;margin-right:auto;margin-left:auto;max-width:1440px;padding:65px 20px 0}@media only screen and (max-width:1439px){.style__container___17K-g{overflow-y:scroll;overflow-x:hidden}}", ""]);

// exports
exports.locals = {
	"container": "style__container___17K-g"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/container/style.css
// module id = 680
// module chunks = 0